//
//
//
//
//
//
//
//
//

  export default {
    name: 'app',
    data (){
      return {
        transitionName : "slide",
        hideHeader: false,
        routerStack: new Set(),
        direction: "", //页面滑动方向： left right 空
      }
    },
    watch : {
        "$route": function(n,o){
//            console.log(n,o);
//            console.log(this.routerStack)
            if(!this.routerStack.size){ // 第一次前进
                this.direction = "left";
                this.routerStack.add(n.name);
            }else if(!this.routerStack.has(n.name)){ // 新页面前进
                this.direction = "left";
                this.routerStack.add(n.name);
            }else{ // 老页面后退
                this.direction = "right";
                this.routerStack.delete(o.name); // 后退后移除打开记录，下次进入就是前进
            }
        }
    },
    methods: {
      debug(ele,fn){
        var count = 0;
        var timeRange = 2000;
        var beginTime,time;
        const that = this;
        ele.addEventListener("click",function() {
          if(count == 0){
            beginTime = new Date().getTime();
            count ++;
          }else{
            time = new Date().getTime();
            if(time - beginTime >= timeRange){
              if(count >= 6){
                fn.call(that);
                count = 0;
              }else{
                count = 0;
                beginTime = null;
              }
            }else{
              count ++;
            }
          }
        },false);
      }
    },
    mounted(){
      if(this.$config.env !== "prod"){
        var that = this;
        this.debug(document, () => {
          that.$vux.toast.show({
            text: "已启用调试模式",
            type: "text",
            onHide: () => {
              that.$router.push({name: 'pagelist'});
            }
          });
        });
      }

      const userAgent = window.navigator.userAgent;
      // console.log("userAgent:",userAgent);
      var flag = false;
      for(let i = 0, len = this.$config.hideHeader.length; i < len; i++){
        let reg = new RegExp(this.$config.hideHeader[i],"i");
        if(reg.test(userAgent)){
          flag = true;
          break;
        }
      }
      if(flag){
        this.hideHeader = true;
      }else{
        this.hideHeader = false;
      }

      //  'English': language == 'en', 'Chinese': language == 'zh'
      const lang = this.$cookie.get("lang");
      if(lang == "en-US"){
        document.body.classList.remove("Chinese");
        document.body.classList.add("English");
      }else if(lang == "zh-CN"){
        document.body.classList.remove("English");
        document.body.classList.add("Chinese");
      }else{
        document.body.classList.remove("English");
        document.body.classList.add("Chinese");
      }

      window.onerror = function (err){
        that.$store.dispatch("addError", {
          page: that.$t(that.$router.currentRoute.meta.title),
          error: err
        });
      }
    }
  }



// WEBPACK FOOTER //
// ./src/App.vue